import {
  dispatch,
  updateCatalogDownloadStatus,
  updateCustomerProfileDownloadStatus,
} from '@zonofi/zono-money-store';
import { verifyCacheIntegrity } from './verify-cache-integrity';

export async function syncCacheWithRedux(customerIds: string[]) {
  const { profileMissing, catalogMissing } =
    await verifyCacheIntegrity(customerIds);

  catalogMissing.forEach((customerId) => {
    dispatch(updateCatalogDownloadStatus({ customerId, status: false }));
  });

  profileMissing.forEach((customerId) => {
    dispatch(
      updateCustomerProfileDownloadStatus({
        customerId,
        status: false,
      })
    );
  });

  return { profileMissing, catalogMissing };
}
